
















































































































































































































































import Vue from 'vue'
import { mapState } from 'vuex'
import SourceSelect from '@/components/source-select.vue'
import { CooldownList } from '@/core/cooldowns'
import { GenerateSettingsRequest } from '@/core/api/generate-settings'
import { TOAST_ERROR_MESSAGE } from '@/plugins/swal'
import { isUserSelectingText } from '@/core/selection'

export default Vue.extend({
  components: {
    SourceSelect,
  },
  props: {
    spider: {
      default: null,
      type: Object,
    },
    errors: {
      type: Object,
      default: (): {} => ({}),
    },
  },
  data: () => ({
    dialog: false,
    validate: false,
    cooldowns: CooldownList,
  }),
  computed: {
    ...mapState('statuses', {
      statuses: (state: any) => state.items,
    }),
    ...mapState('plugins', {
      plugins: (state: any) => state.items,
    }),
    ...mapState('proxies', {
      proxies: (state: any) => state.items,
    }),
    ...mapState('users', {
      users: (state: any) => {
        return [{ id: null, username: 'Не задан' }, ...state.items]
      },
    }),
    startUrls(): Array<string> {
      return this.spider['settings']['start_urls'].split('\n').filter(x => x.match('^https?://.+'))
    },
    readonly(): boolean {
      return this.spider && this.spider.readonly
    },
  },
  created() {
    this.$store.dispatch('plugins/FETCH')
    this.$store.dispatch('proxies/FETCH')
  },
  methods: {
    onSourcesClick() {
      if (!isUserSelectingText()) {
        this.dialog = true
      }
    },
    onSourcesDoubleClick() {
      this.dialog = true
    },
    onSourceSelect(source) {
      this.spider.source = source
      // use setting autofill only on spider creation
      if (this.spider.id == null) {
        this.autofillSettings(source)
      }

      this.dialog = false
    },
    autofillSettings(source) {
      if (source == null || source.url == null) {
        return
      }

      this.spider.settings['start_urls'] = source.url
      this.spider.settings['rules_allow'] = '/'
      try {
        this.spider.settings['allowed_domains'] = new URL(source.url).hostname
      } catch {
        this.spider.settings['allowed_domains'] = ''
      }
    },
    generateSettings() {
      const source = this.spider.source
      if (source == null) {
        return
      }
      new GenerateSettingsRequest().send(source).then(
        r => {
          const { data } = r.data
          Object.assign(this.spider.settings, data.spider.settings)
        },
        e => {
          this.$toastError.fire(e?.response?.data?.message || TOAST_ERROR_MESSAGE)
        },
      )
    },
  },
})
